export default __webpack_public_path__ + "static/media/cyware.b537d2e5.png";